import React from "react";
import './report-link.scss';

interface ReportLinkProps {
    handleClick: React.MouseEventHandler<HTMLDivElement>;
    label?: string;
}

export const ReportLink: React.FC<ReportLinkProps> = ({handleClick, label = 'Сообщить об ошибке в документе'}) => (
        <div className="report-link" onClick={handleClick}>
            {label}
        </div>
)
